import ThankYouAsk from '$lib/client/asks/thank-you.svelte';
import ShareAsk from '$lib/client/asks/share.svelte';
import MailingListAsk from '$lib/client/asks/mailing_list.svelte';
import ComingUp from '$lib/client/feed/coming-up.svelte';
import NewTrack from '$lib/client/feed/new_track.svelte';
import Favourite from '$lib/client/feed/favourite.svelte';
import ClickAsk from '$lib/client/asks/click.svelte';
import EventAsk from '$lib/client/asks/event.svelte';

export const components = {
  thank_you: {
    title: 'Thank You',
    component_name: ThankYouAsk
  },
  share: {
    title: 'Share',
    component_name: ShareAsk
  },
  mailing_list: {
    title: 'Mailing List',
    component_name: MailingListAsk
  },
  favourite: {
    title: 'Share your ❤ track',
    component_name: Favourite,
  },
  new_track: {
    title: 'New Track',
    component_name: NewTrack
  },
  click: {
    title: "Visit",
    component_name: ClickAsk
  },
  event: {
    title: "Upcoming Show",
    component_name: EventAsk
  }
};
